
const apiConfig = {
                baseURL: "https://api.bajipro.net",
            //  baseURL: "http://localhost:5000",
};

export default apiConfig;